import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_REIMBURSEMENT_RECEIVED_LIST: string = typeCreatorV2(
  'ReimbursmentsReceivedListReducer',
  'SetReimbursmentsReceivedList'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'ReimbursmentsReceivedListReducer',
  'SetUnreadNotificationCount'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'ReimbursmentsReceivedListReducer',
  'SetMemberStateCountriesExcludeCyprus'
);
